export default "__VITE_ASSET__B$XsZf4Y__"